import { isEqual } from 'lodash';
import { tIntegration } from './Integrations.types';

/**
 * Returns `integrations` with `entry`'s channel merged in, replacing an
 * existing row for that channel rather than appending a second one.
 *
 * Merges rather than replaces so fields the caller does not carry (such as a
 * Messenger row's `pages`) survive the write. Returns the original array
 * unchanged when the row already matches, so a vacuous write does not
 * re-render every consumer of the integrations context.
 */
export function upsertIntegration(
  integrations: tIntegration[],
  entry: tIntegration,
): tIntegration[] {
  const existing = integrations.find(
    (integration) => integration.label === entry.label,
  );

  if (!existing) {
    return [...integrations, entry];
  }

  const merged = { ...existing, ...entry };

  if (isEqual(existing, merged)) {
    return integrations;
  }

  return integrations.map((integration) =>
    integration.label === entry.label ? merged : integration,
  );
}
